/* eslint-disable */
import L from 'leaflet';
import './pdf-sheet-input.scss';
import { PdfSheetInput } from './pdf-sheet-input';
import './pdf-sheet-size-input.scss';

export class PdfSheetSizeInput extends PdfSheetInput {
  _setInput(val) {
    val = this.options.setValue(val);
    this._inputX.value = val[0];
    this._inputY.value = val[1];
  }

  _createInput() {
    const opt = this.options;
    const input = L.DomUtil.create('div', 'pdf-sheet-plugin__selector--inputXY');
    const inputX = L.DomUtil.create('input', 'pdf-sheet-plugin__selector--input-size', input);

    const separator = L.DomUtil.create('div', 'pdf-sheet-plugin__selector--separator', input);
    separator.innerHTML = this.options.separator || 'x';

    const inputY = L.DomUtil.create('input', 'pdf-sheet-plugin__selector--input-size', input);

    const currentValue = opt.selectArray.find((x) => {
      const value = x.name;
      return value === this.options.value;
    });
    [inputX, inputY].forEach((x) => {
      L.DomEvent.on(x, 'change', () => {
        let value = `${inputX.value}-${inputY.value}`;
        this.redraw(value);
        value = opt.setValue ? opt.setValue(value) : value;
      });
    });
    this._inputX = inputX;
    this._inputY = inputY;
    this._setInput(currentValue.value);

    return input;
  }
}
